<div style="padding:20px"> 
    <!-- <button class="btn" (click)="now=item.id;pageobj.page=0;init_list()" [ngClass]="now!=item.id?'btn-secondary':'btn-danger'" *ngFor="let item of menulist">{{item.name}}</button> -->

    <button class="btn btn-primary" (click)="add_new()">新增一句話提示</button>
    <table style="margin-top: 10px;"  class="table table-responsive-sm" *ngIf="data.length>0" style="margin-top: 6px;">
        <thead >
          <tr class="table-primary" style="font-size:18px;">
            <th *ngFor="let column of table_column_list[now]">{{column}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of data; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
              <td *ngIf="now=='0'">{{item.title}}</td>
              <td *ngIf="now=='0'"><img loading="lazy" style="height: 120px;" [src]="item.pic"></td>
              <td *ngIf="now=='3'">{{item.title}}</td>
              <td ><span class="easy_show">{{item.des}}</span></td>
              <td *ngIf="now!='3'" >{{item.type_name}}</td>
              <td >{{item.points}}</td>

              <td *ngIf="now=='0'">{{item.start_dt}}</td>
              <td *ngIf="now=='1'">{{item.nt_dollar}}</td>
              <td *ngIf="now=='2'">{{item.rate}}</td>
   
              <td *ngIf="now=='0'">{{item.end_dt}}</td>
              <td *ngIf="now=='0'">{{item.show_limit*1==-1?'永久':item.show_limit}}</td>
              <td>{{item.is_enable*1==1?'上架':'下架'}}</td>             
              <td><button (click)="edit_data=item;tmp_img_b64=''"  class="btn btn-danger" data-toggle="modal" data-target=".bd-example-modal-md">點我編輯</button></td>             
          </tr>
        </tbody>
      </table>
      <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
      <div *ngIf="data.length==0">無資料</div>
  </div>

  <div 
*ngIf="edit_data"
class="modal fade bd-example-modal-md" tabindex="-1"
 role="dialog"  data-keyboard="false" data-backdrop="static" 
 aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"

 >
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
          <h4 class="modal-title">編輯設定</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <div class="modal-body"> 
        <div class="wrape_item" *ngIf="now=='0'||now=='3'">
           <span class="show_title" >名稱:</span><input type="text" 
            [(ngModel)]="edit_data.title" 
            class="form-control show_input" 
          >
        </div>
        <div class="wrape_item" *ngIf="now=='0'">
          <span class="show_title">圖片:</span>
          <span (click)="edit_data.pic=''" style="cursor:pointer;"><img loading="lazy"  [src]="tmp_img_b64?tmp_img_b64:edit_data.pic" style="width: 100px;display: inline;"></span>
        
          <div class="btn btn-info" style="position:relative;margin-left:10px;">
            <input style="opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;" type="file" (change)="upload($event)"
            placeholder="Upload file" accept=".jpeg,.jpg,.png,.gif">點我上傳
          </div>
       </div>
        <div class="wrape_item" >
          <span class="show_title">描述:</span>
          <textarea  [(ngModel)]="edit_data.des" 
          class="form-control " style="width: 390px;height: 140px;"></textarea>
       </div>
        <div class="wrape_item">
            <span class="show_title">類型:</span>&nbsp;&nbsp;
            <select class="form-control show_input"
                [(ngModel)]="edit_data.type"
            >
                <option default disabled>請選擇類型</option>
                <option *ngFor="let item of status_option" [ngValue]="item.id">{{item.name}}</option>
            </select>
        </div>
        <div class="wrape_item">
            <span class="show_title">數值:</span><input type="number" 
             [(ngModel)]="edit_data.points" 
             class="form-control show_input" 
           >
         </div>
         <div class="wrape_item" *ngIf="now=='1'">
            <span class="show_title">儲值台幣:</span><input type="number" 
             [(ngModel)]="edit_data.nt_dollar" 
             class="form-control show_input" 
           >
         </div>
         <div class="wrape_item" *ngIf="now=='2'">
            <span class="show_title">匯率:</span><input type="number" 
             [(ngModel)]="edit_data.rate" 
             class="form-control show_input" 
           >
         </div>
         <div class="wrape_item">
            <span class="show_title">狀態:</span>
            <button [ngClass]="edit_data.is_enable*1===1?'btn-danger':'btn-secondary'" (click)="edit_data.is_enable=1" class="btn">上架</button>
            <button [ngClass]="edit_data.is_enable*1===0?'btn-danger':'btn-secondary'" (click)="edit_data.is_enable=0" class="btn">下架</button>
         </div>
         <div class="wrape_item" *ngIf="now=='0'">
            <span class="show_title">開始時間:</span>
            <input type="datetime-local" class="form-control show_input" (ngModelChange)="edit_data.start_dt = $event"  [ngModel]="edit_data.start_dt | date:'yyyy-MM-ddTHH:mm'" />
         </div>
         <div class="wrape_item" *ngIf="now=='0'">
          <span class="show_title">結束時間:</span>
            <input type="datetime-local" class="form-control show_input" (ngModelChange)="edit_data.end_dt = $event"  [ngModel]="edit_data.end_dt | date:'yyyy-MM-ddTHH:MM'" />
         </div>
         <div class="wrape_item" *ngIf="now=='0'">
          <span class="show_title">出現次數:</span><input type="number" 
             [(ngModel)]="edit_data.show_limit" 
             class="form-control show_input" 
           >
           <span style="color:#aaa;font-size:8px;display:block">輸入-1代表每次都show</span>
         </div>
 

      </div>

      <div class="modal-footer">
          <button type="button"  (click)="save()"  class="btn btn-primary" data-dismiss="modal">確認</button>
          <button type="button"  (click)="init_list()" class="btn btn-danger" data-dismiss="modal">取消</button>
      </div>
      </div>
  </div>
</div>
<app-spinner [loading]="loading"></app-spinner>